module.exports = __webpack_public_path__ + "static/img/p-28.77ba1fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-28.png
// module id = cNsC
// module chunks = 0